import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

export function antiforgeryTokenInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    let headers = {};
    headers = {
        "X-CSRF": "1"
    };

    const clonedRequest = request.clone({
        setHeaders: headers,
        withCredentials: true
    });
    return next(clonedRequest);
}
